import React from 'react';
import { Button, Container, FlexboxGrid, Panel, Stack, Text } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import usePlaceNavigate from '../hooks/usePlaceNavigate';

const ErrorPage = ({
  errorHeader = 'An unexpected error occurred.',
  message = 'Page Not Found',
  showActionButton = false,
  showBackButton = true,
  errorDetails = '',
}) => {
  const navigate = useNavigate();
  const placeNavigate = usePlaceNavigate();

  const handleGoHome = () => {
    placeNavigate('/dashboard');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container
      role="main"
      as={'main'}
      id="main-content"
      tabIndex={-1}
      aria-label={errorHeader}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Panel
        bordered
        shaded
        style={{
          textAlign: 'center',
          padding: '40px',
          maxWidth: '500px',
          width: '100%',
        }}
      >
        <h1 style={{ fontSize: '72px', marginBottom: '20px' }}>
          {errorHeader}
        </h1>
        {message?.length > 0 && (
          <p style={{ fontSize: '18px', marginBottom: '40px' }}>{message}</p>
        )}
        {errorDetails?.length > 0 && <Text>{errorDetails}</Text>}
        <Stack direction="column">
          <FlexboxGrid
            justify="center"
            style={{ width: '100%' }}
          >
            {showActionButton && (
              <Button
                className="btn-primary"
                onClick={handleGoHome}
                block
              >
                Return to Dashboard
              </Button>
            )}
            {showBackButton && (
              <Button
                className="btn-secondary mt-8"
                onClick={handleGoBack}
                block
              >
                Back
              </Button>
            )}
          </FlexboxGrid>
        </Stack>
      </Panel>
    </Container>
  );
};

export default ErrorPage;
